export const SIGNIN_QUERY_KEY = 'signin';
export const SIGNUP_QUERY_KEY = 'signup';
export const TRANSLATIONS_QUERY_KEY = 'translations';
export const CHECK_EMAIL_QUERY_KEY = 'check-email';
export const SEND_PASSWORD_RESET_QUERY_KEY = 'send-password-reset';
export const RESET_PASSWORD_QUERY_KEY = 'reset-password';
export const USER_PROFILE_QUERY_KEY = 'user-profile';
export const SOCIAL_PROVIDERS_QUERY_KEY = 'social-providers';
export const CREATE_SUPPORT_CASE_QUERY_KEY = 'create-support-case';
export const SUPPORT_CONFIGURATIONS_QUERY_KEY = 'support-configurations';
export const SUPPORT_FAQS_QUERY_KEY = 'support-faqs';

// Booking query keys
export const LOCATIONS_QUERY_KEY = 'locations';
export const LOCATION_QUERY_KEY = 'location';
export const LOCATION_SERVICES_QUERY_KEY = 'location-services';
export const AVAILABILITY_QUERY_KEY = 'availability';
export const BOOKINGS_QUERY_KEY = 'bookings';
export const BOOKING_QUERY_KEY = 'booking';
export const CREATE_BOOKING_QUERY_KEY = 'create-booking';
export const UPDATE_BOOKING_QUERY_KEY = 'update-booking';
export const CANCEL_BOOKING_QUERY_KEY = 'cancel-booking';
export const BOOKING_BY_CODE_QUERY_KEY = 'booking-by-code';
export const UPDATE_BOOKING_BY_CODE_QUERY_KEY = 'update-booking-by-code';
export const CANCEL_BOOKING_BY_CODE_QUERY_KEY = 'cancel-booking-by-code';
